/**
 * Provides JS functionality for tracking alert display.
 */
export class PridePoints extends DrupalBehavior {
  onContent(context) {
    let pridePointsTimeline = gsap.timeline({ paused: true });

    var pridePoints = context.querySelectorAll('.pride-points--items');
    pridePoints.forEach((point) => {
      var pridePointsItems = point.querySelectorAll('.pride-points--stat');
      pridePointsItems.forEach((item) => {
        var numberElement = item.querySelector('.pride-points--stat--number');
        var newValue = parseFloat(numberElement.textContent.replace(/,/g, ''));
        var number = {
          value: 0,
        };
        var numberFormat = new Intl.NumberFormat();
        pridePointsTimeline.to(
          number,
          {
            duration: 2,
            ease: 'sine.inOut',
            value: newValue,
            onUpdate: function () {
              if (newValue % 1 == 0) {
                numberElement.textContent = numberFormat.format(
                  Math.floor(number.value)
                );
              } else {
                numberElement.textContent = numberFormat.format(
                  number.value.toFixed(2)
                );
              }
            },
          },
          0
        );
      });

      pridePointsTimeline.progress(1).progress(0);
      let io = new IntersectionObserver(intersectionHandler);
      io.observe(point);
    });

    function intersectionHandler(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pridePointsTimeline.play();
          observer.unobserve(entry.target);
        }
      });
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'pride_points', PridePoints);
